import API from '../../../../network/dashboardAPI';

export const fetchSupplierProductBySupplierID = async (supplier_id) => {
    try {
        if (!supplier_id) return { data: [], error: "Supplier ID is required" };
        const postData = { "supplier_id": supplier_id };
        const response = await API.getAdminSupplierProductBySupplierId(postData);
        return response.json();
    } catch (error) {
        console.error("Error fetching products:", error);
        return { products: [], error: error.message || "Failed to fetch products" };
    }
};